"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeSide = exports.OracleSource = exports.PositionDirection = exports.SwapDirection = void 0;
// # Utility Types / Enums / Constants
class SwapDirection {
}
exports.SwapDirection = SwapDirection;
SwapDirection.ADD = { add: {} };
SwapDirection.REMOVE = { remove: {} };
class PositionDirection {
}
exports.PositionDirection = PositionDirection;
PositionDirection.LONG = { long: {} };
PositionDirection.SHORT = { short: {} };
class OracleSource {
}
exports.OracleSource = OracleSource;
OracleSource.PYTH = { pyth: {} };
OracleSource.SWITCHBOARD = { switchboard: {} };
var TradeSide;
(function (TradeSide) {
    TradeSide[TradeSide["None"] = 0] = "None";
    TradeSide[TradeSide["Buy"] = 1] = "Buy";
    TradeSide[TradeSide["Sell"] = 2] = "Sell";
})(TradeSide = exports.TradeSide || (exports.TradeSide = {}));
